import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUmbrella = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 537,
	height: 323,
	fill: "none",
	viewBox: "0 0 537 323",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 182.3,
			cy: 40,
			fill: "#F5D493",
			rx: 182.3,
			ry: 40,
			transform: "matrix(-1 0 0 1 428.6 242.2)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 74.3,
			cy: 16.3,
			fill: "#F5D493",
			rx: 74.3,
			ry: 16.3,
			transform: "matrix(-1 0 0 1 148.6 264.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M123.5 228.3h3.3l-5.2 50.6H118l5.5-50.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m122.4 226.4 1.1 1.9-5.5 50.6-1.3-1 5.7-51.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m105.8 190 1.7-2.4 41 98-2 2-40.7-97.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M107.5 187.6h4.4l41.1 98h-4.5l-41-98Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m148.5 285.5-2 2h5.3l1.1-2h-4.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M107.4 190.3H54s3.1 28.4 10 45a209.3 209.3 0 0 0 15.6 27.9h50s-11-22.8-15.5-38.3a315 315 0 0 1-6.7-34.6Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_16400_21184",
			width: 77,
			height: 72,
			x: 53,
			y: 190,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "M107.4 190.3H54s3.1 28.4 10 45a272.7 272.7 0 0 0 13.2 26.5h52.4s-11-21.4-15.5-37c-3.8-13.2-6.7-34.5-6.7-34.5Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#FB8431",
			mask: "url(#mask0_16400_21184)",
			children: /* @__PURE__ */ _jsx("path", { d: "M106 190.3h-5.4s4 28 9.3 45.2a123 123 0 0 0 14.7 27.7h3s-8.5-16.8-12.8-30.2c-4.9-15.3-8.7-42.7-8.7-42.7Zm-11.4 0H89s4 28 9.3 45.2c3.6 12 14.6 27.7 14.6 27.7h3s-8.4-16.8-12.7-30.2c-5-15.3-8.7-42.7-8.7-42.7Zm-10.9 0h-5.5s4 28 9.3 45.2c3.7 12 14.7 27.7 14.7 27.7h3s-8.4-16.8-12.8-30.2a333 333 0 0 1-8.7-42.7Zm-11.8 0h-5.5s4 28 9.3 45.2c3.6 12 14.6 27.7 14.6 27.7h3s-8.4-16.8-12.7-30.2a333 333 0 0 1-8.7-42.7Zm-11.2 0h-5.5s5.6 32 10.8 49.3a81.6 81.6 0 0 0 13.2 23.6h3s-8.5-16.8-12.8-30.2a333 333 0 0 1-8.7-42.7Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m149.2 246.9 3.4 1.1-26.3 30.2h-4.5l27.4-31.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m148.5 243.3.7 3.6-27.3 31.3.2-4.5 26.4-30.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m149.2 246.9-.7-3.6 3.3.9.8 3.7-3.4-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M138.5 263H86.2s3.5-3.5 4.7-6.3c1-2.5 1.5-6.8 1.5-6.8h53s0 4.9-1.4 7.5c-1.5 2.7-5.5 5.6-5.5 5.6Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_16400_21184",
			width: 60,
			height: 14,
			x: 86,
			y: 249,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "M138.5 263H86.2s3.5-3.5 4.7-6.3c1-2.5 1.5-6.8 1.5-6.8h53s0 4.9-1.4 7.5c-1.5 2.7-5.5 5.6-5.5 5.6Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#FB8431",
			mask: "url(#mask1_16400_21184)",
			children: /* @__PURE__ */ _jsx("path", { d: "m112 263.2-5.5-.2s6-2 8-5.6c1.3-2.4 2-7.5 2-7.5h5.8s-.7 5.2-1.9 7.5c-2 3.8-8.4 5.8-8.4 5.8Zm-11.7 0-5.8-.2s5.9-2 8-5.6c1.3-2.4 1.6-7.5 1.6-7.5h6.1s-.6 5.2-1.8 7.5c-2 3.8-8 5.8-8 5.8Zm-9.1 0-4.5-.2s3.2-2 5.2-5.6c1.4-2.4 1.7-7.5 1.7-7.5h4.8s-.7 5.2-1.9 7.5c-2 3.8-5.3 5.8-5.3 5.8Zm32.8 0-5.5-.2s6.3-2 8.3-5.6c1.4-2.4 2-7.5 2-7.5h5.5s-.7 5.2-1.9 7.5c-2 3.8-8.3 5.8-8.3 5.8Zm10.9 0-5.5-.2s6.6-2 8.6-5.6c1.4-2.4 2-7.5 2-7.5h5.1s-.6 5.2-1.8 7.5c-2 3.8-8.4 5.8-8.4 5.8Z" })
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 55.9,
			height: 4.4,
			x: 91.8,
			y: 245.5,
			fill: "#fff",
			rx: 2.2
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FB8431",
			d: "M139.2 245.5h4.6a2.2 2.2 0 0 1 0 4.4h-4.6l.3-.2a2.6 2.6 0 0 0-.3-4.2Zm-11.2 0h4.6a2.2 2.2 0 0 1 0 4.4H128l.3-.2a2.6 2.6 0 0 0-.3-4.2Zm-11.5 0h4.6a2.2 2.2 0 0 1 0 4.4h-4.6l.3-.2a2.6 2.6 0 0 0-.3-4.2Zm-11.5 0h4.6a2.2 2.2 0 0 1 0 4.4H105l.3-.2a2.6 2.6 0 0 0-.3-4.2Zm-11.5 0H98c1.3 0 2.2 1 2.2 2.2 0 1.3-1 2.2-2.2 2.2h-4.5l.3-.2a2.6 2.6 0 0 0-.3-4.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M63.8 228.3h3.4l-5.3 50.6h-3.5l5.4-50.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m62.8 226.4 1 1.9-5.4 50.6-1.4-1 5.8-51.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m90 247.6 3.3 1L67 279h-4.5l27.4-31.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m89.2 244 .7 3.6-27.3 31.3.2-4.6L89.2 244Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m90 247.6-.8-3.6 3.2.9.9 3.7-3.4-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAE23",
			d: "m47.1 190 1.8-2.4 41 98-2 2L47.2 190Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "M48.9 187.6h4.4l41 98H90l-41-98Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFC45F",
			d: "m89.9 285.5-2 2H93l1.2-2H90Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M402.5.6 325.2 85s17.7 20 33 26.4c14.8 6.3 41 5 41 5l3.3-116Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m402.8.3-143.9 54s12.2 18.7 27 25c14.8 6.2 39.3 5.8 39.3 5.8L402.8.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M402.5 0 468 144.1s-17.7 1.4-38.8-4.5c-21-5.9-30-22.7-30-22.7L402.4 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "m402.8.3-208 23s11.9 19.4 27.6 27.3c15.7 7.8 38.8 3 38.8 3L402.8.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "m402.5.3 117.7 164s-11.4 3-27.8-3.3a59 59 0 0 1-24.2-16.6L402.5.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D66313",
			d: "M309.2 173.3c-15 39.3-31.4 102.9-31.4 102.9h14.6s12.6-58 25.2-93.9a985.3 985.3 0 0 1 32.6-75.8l-9-5.4s-21 43.4-32 72.2Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 212.7,
			cy: 274.2,
			fill: "#F5D493",
			rx: 26.3,
			ry: 1.7
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 220.3,
			cy: 245.5,
			fill: "#fff",
			rx: 28.8,
			ry: 27.2
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_16400_21184",
			width: 59,
			height: 55,
			x: 191,
			y: 218,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 220.3,
				cy: 245.5,
				fill: "#D9D9D9",
				rx: 28.8,
				ry: 27.2
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_16400_21184)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#F76E6E",
					d: "M243 228.2c-4.6-2.7-15.9-.6-15.9-.6s14.5 8.6 18.7 18.7c2.3 5.7 1.7 12.7 1.7 12.7s9.9-22.5-4.4-30.8Zm-17-9.4c2.6 1.9 3.1 8.2 3.1 8.2s-9-4.8-16.5-4.7c-4.3 0-9.5.8-9.5.8s14.8-9.9 22.9-4.3Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#F76E6E",
					d: "M225 253.3c-2 7.8-8.9 21-8.9 21l-17-6.5-6.5-12.8s5.4-9.8 10.4-14.7c7.8-7.7 24.6-13.4 24.6-13.4s0 16.3-2.6 26.4Z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 228,
					cy: 227.8,
					r: 4.8,
					fill: "#E33C78"
				})
			]
		})
	]
});
export default SvgUmbrella;
